
export { stringToAge } from "/home/runner/work/apollo/apollo/packages/core/utils/date/src/string-to-age/string-to-age.ts"